import { instanceConexao } from "services/axiosServices";
import { AxiosRequestConfig } from "axios";
import { RevendaUnidadeEditar } from "../novaRevenda/utils";

const toNumber = (value: string | number): number | null => {
  if (typeof value === "number") return value;
  if (typeof value !== "string" || value.trim() === "") return 0;

  return parseFloat(value.replace(/\./g, "").replace(",", "."));
};

/**
 * Função para editar uma unidade de revenda.
 *
 * @param {RevendaUnidadeEditar} params - Parâmetros para edição da unidade de revenda.
 * @returns {Promise<any>} - Resposta da API.
 */
export const putRevendaUnidade = async (
  params: RevendaUnidadeEditar
): Promise<any> => {
  const url = "/api/RevendaUnidade";
  const { authToken, ...parameters_ } = params;
  const parameters = {
    ...parameters_,
    vagas:
      parameters_.vagas?.length === 1 &&
      parameters_.vagas?.[0]?.tipoVaga === null
        ? []
        : parameters_.vagas
            ?.filter((item) => item?.tipoVaga)
            ?.map((vaga) => ({ tipoVaga: vaga.tipoVaga })),
    proprietarios: parameters_.proprietarios.map((proprietario) => ({
      nome: proprietario.nome,
      email: proprietario.email,
      celular: proprietario.celular,
    })),
    valorCondominio: toNumber(parameters_.valorCondominio),
    valorIptu: toNumber(parameters_.valorIptu),
    areaUtil: toNumber(parameters_.areaUtil),
    valorUnidade: toNumber(parameters_.valorUnidade),
    saldoDevedor: toNumber(parameters_.saldoDevedor),
  };
  const config: AxiosRequestConfig = {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  };
  const response = await instanceConexao.put(url, parameters, config);
  return response?.data;
};
